import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import _ from 'lodash';
import { defineMessages } from 'react-intl';
import Layout from '../../../../components/Layout/Layout';
import isLoggedIn from '../../../../helpers/checkAuth';
import notAuthorized from '../../../not-authorized';
import CourseDetailsDiscussion from './CourseDetailsDiscussion';
import notFound from '../../../not-found/index';
import { getCourseBySlug } from '../../../../actions/courseDetails';
import { getDiscussion } from '../../../../actions/editDiscussion';
var messages = defineMessages({
  title: {
    id: "CourseDetailsDiscussions.Discussion.title",
    defaultMessage: [{
      "type": 1,
      "value": "discussionName"
    }, {
      "type": 0,
      "value": " - "
    }, {
      "type": 1,
      "value": "courseName"
    }, {
      "type": 0,
      "value": " - Course"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
    var store, params, fetch, formatMessage, courseSlug, discussionId, _store$getState, auth, promises, requests, notFoundReq, _store$getState2, courseDetails, editDiscussion, title;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          store = context.store, params = context.params, fetch = context.fetch, formatMessage = context.intl.formatMessage;
          courseSlug = params.courseSlug, discussionId = params.discussionId;
          _store$getState = store.getState(), auth = _store$getState.auth;
          if (isLoggedIn(auth)) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return", notAuthorized(context));
        case 5:
          promises = [];
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var res, resText, json, result, middlewareError;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return store.dispatch({
                    type: getCourseBySlug(courseSlug).types[0]
                  });
                case 2:
                  _context.prev = 2;
                  _context.next = 5;
                  return getCourseBySlug(courseSlug).promise(fetch);
                case 5:
                  res = _context.sent;
                  _context.next = 8;
                  return res.text();
                case 8:
                  resText = _context.sent;
                  json = resText ? JSON.parse(resText) : {};
                  if (!(res.status !== 200)) {
                    _context.next = 14;
                    break;
                  }
                  if (![403, 404].includes(res.status)) {
                    _context.next = 13;
                    break;
                  }
                  return _context.abrupt("return", notFound(context));
                case 13:
                  return _context.abrupt("return", store.dispatch({
                    error: json,
                    type: getCourseBySlug(courseSlug).types[2]
                  }));
                case 14:
                  result = {
                    status: res.status,
                    json: json
                  };
                  return _context.abrupt("return", store.dispatch({
                    result: result,
                    type: getCourseBySlug(courseSlug).types[1]
                  }));
                case 18:
                  _context.prev = 18;
                  _context.t0 = _context["catch"](2);
                  middlewareError = new Error("MIDDLEWARE ERROR: ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message));
                  middlewareError.stack = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.stack;
                  console.error(middlewareError);
                  return _context.abrupt("return", store.dispatch({
                    error: _context.t0,
                    type: getCourseBySlug(courseSlug).types[2]
                  }));
                case 24:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[2, 18]]);
          })));
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var res, resText, json, result, middlewareError;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return store.dispatch({
                    type: getDiscussion(discussionId).types[0]
                  });
                case 2:
                  _context2.prev = 2;
                  _context2.next = 5;
                  return getDiscussion(discussionId).promise(fetch);
                case 5:
                  res = _context2.sent;
                  _context2.next = 8;
                  return res.text();
                case 8:
                  resText = _context2.sent;
                  json = resText ? JSON.parse(resText) : {};
                  if (!(res.status !== 200)) {
                    _context2.next = 14;
                    break;
                  }
                  if (![403, 404].includes(res.status)) {
                    _context2.next = 13;
                    break;
                  }
                  return _context2.abrupt("return", notFound(context));
                case 13:
                  return _context2.abrupt("return", store.dispatch({
                    error: json,
                    type: getDiscussion(discussionId).types[2]
                  }));
                case 14:
                  result = {
                    status: res.status,
                    json: json
                  };
                  return _context2.abrupt("return", store.dispatch({
                    result: result,
                    type: getDiscussion(discussionId).types[1]
                  }));
                case 18:
                  _context2.prev = 18;
                  _context2.t0 = _context2["catch"](2);
                  middlewareError = new Error("MIDDLEWARE ERROR: ".concat(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message));
                  middlewareError.stack = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.stack;
                  console.error(middlewareError);
                  return _context2.abrupt("return", store.dispatch({
                    error: _context2.t0,
                    type: getDiscussion(discussionId).types[2]
                  }));
                case 24:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[2, 18]]);
          })));
          _context3.next = 10;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 10:
          requests = _context3.sent;
          notFoundReq = _.find(requests, function (item) {
            return _.get(item, 'status') === 404;
          });
          if (!notFoundReq) {
            _context3.next = 14;
            break;
          }
          return _context3.abrupt("return", notFoundReq);
        case 14:
          _store$getState2 = store.getState(), courseDetails = _store$getState2.courseDetails, editDiscussion = _store$getState2.editDiscussion;
          title = formatMessage(messages.title, {
            courseName: _.get(courseDetails, 'course.name', ''),
            discussionName: _.get(editDiscussion, 'discussion.name', '')
          });
          return _context3.abrupt("return", {
            chunks: ['course-details'],
            title: title,
            component: /*#__PURE__*/_jsx(Layout, {
              context: context
            }, void 0, /*#__PURE__*/_jsx(CourseDetailsDiscussion, {
              data: {},
              title: title
            }))
          });
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _action.apply(this, arguments);
}
export default action;